import * as React from "react";

export class Image extends React.Component<{ source: string, class: string }, {}> {

    render() {
        const imageStyles = {
            backgroundImage: `url(${this.props.source})`
        };

        return (
            <div className={this.props.class} style={imageStyles} />
        )
    }
}